// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K5Cc9mxR6qsBlMKK{display:flex;flex-direction:column;justify-content:space-between;height:100%}.K5Cc9mxR6qsBlMKK .pMpZ6foN8XstHrwf{width:100%;height:248px;display:grid;place-items:center}.WXD6J_mDDj8clv3u{border-radius:4px;background-color:var(--py-neutral-1);padding:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartContainer": `K5Cc9mxR6qsBlMKK`,
	"factorsPolygon": `pMpZ6foN8XstHrwf`,
	"selectionChip": `WXD6J_mDDj8clv3u`
};
export default ___CSS_LOADER_EXPORT___;
